import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'dashboard-funnels',
  storeModule.createStoreModule('dashboard-funnels', {
    fetchListURL: 'dashboard/funnels'
  })
)
